import type { CSSProperties } from 'react';

/* Minimal 1.6px-stroke line icons (currentColor). Ported 1:1 from the
   prototype so the visual language is identical. To move to Lucide later,
   keep this component's API and swap the lookup. */
export const ICON_PATHS = {
  home: 'M3 11l9-7 9 7M5 10v9h5v-6h4v6h5v-9',
  book: 'M4 5a2 2 0 012-2h12v16H6a2 2 0 00-2 2zM18 3v16M8 7h6M8 10h6',
  stack: 'M12 3l9 5-9 5-9-5 9-5zM3 13l9 5 9-5M3 17l9 5 9-5',
  award: 'M12 14a6 6 0 100-12 6 6 0 000 12zM9 13l-1 8 4-2 4 2-1-8',
  user: 'M12 12a4 4 0 100-8 4 4 0 000 8zM5 20a7 7 0 0114 0',
  check: 'M4 12l5 5L20 6',
  checkCircle: 'M9 12l2 2 4-4M12 21a9 9 0 100-18 9 9 0 000 18z',
  chevR: 'M9 5l7 7-7 7',
  chevL: 'M15 5l-7 7 7 7',
  chevD: 'M5 9l7 7 7-7',
  clock: 'M12 21a9 9 0 100-18 9 9 0 000 18zM12 7v5l3 2',
  cal: 'M3 8h18M7 3v3M17 3v3M5 5h14a1 1 0 011 1v13a1 1 0 01-1 1H5a1 1 0 01-1-1V6a1 1 0 011-1z',
  pin: 'M12 21s7-5.6 7-11a7 7 0 10-14 0c0 5.4 7 11 7 11zM12 13a3 3 0 100-6 3 3 0 000 6z',
  qr: 'M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h3v3h-3zM20 14v6M17 20h3',
  search: 'M11 19a8 8 0 100-16 8 8 0 000 16zM21 21l-4.3-4.3',
  bell: 'M18 8a6 6 0 10-12 0c0 7-3 9-3 9h18s-3-2-3-9M13.7 21a2 2 0 01-3.4 0',
  plus: 'M12 5v14M5 12h14',
  x: 'M6 6l12 12M18 6L6 18',
  play: 'M7 4l13 8-13 8z',
  lock: 'M6 11h12v9H6zM8 11V8a4 4 0 018 0v3',
  video: 'M3 6h13v12H3zM16 10l5-3v10l-5-3',
  file: 'M6 3h8l4 4v14H6zM14 3v4h4',
  users: 'M9 11a4 4 0 100-8 4 4 0 000 8zM2 21a7 7 0 0114 0M17 11a4 4 0 000-8M22 21a7 7 0 00-5-6.7',
  chart: 'M4 20V4M4 20h16M8 16v-4M12 16V8M16 16v-7',
  bldg: 'M4 21V5a2 2 0 012-2h8a2 2 0 012 2v16M8 7h2M8 11h2M12 7h2M12 11h2M4 21h16',
  shield: 'M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6zM9 12l2 2 4-4',
  mail: 'M3 5h18v14H3zM3 6l9 7 9-7',
  phone: 'M5 4h4l2 5-3 2a12 12 0 005 5l2-3 5 2v4a2 2 0 01-2 2A16 16 0 013 6a2 2 0 012-2',
  download: 'M12 3v12M7 11l5 5 5-5M5 21h14',
  scan: 'M4 7V5a1 1 0 011-1h2M17 4h2a1 1 0 011 1v2M20 17v2a1 1 0 01-1 1h-2M7 20H5a1 1 0 01-1-1v-2M3 12h18',
  arrowR: 'M5 12h14M13 6l6 6-6 6',
  chevronL: 'M15 18l-6-6 6-6',
  dots: 'M5 12h.01M12 12h.01M19 12h.01',
  edit: 'M4 20h4L19 9l-4-4L4 16zM14 6l4 4',
  filter: 'M3 5h18l-7 8v6l-4-2v-4z',
  star: 'M12 4l2.4 5 5.6.6-4 3.8 1 5.6L12 16l-5 2.6 1-5.6-4-3.8 5.6-.6z',
  globe: 'M12 21a9 9 0 100-18 9 9 0 000 18zM3 12h18M12 3c2.5 2.5 2.5 15 0 18M12 3c-2.5 2.5-2.5 15 0 18',
  layers2: 'M3 7l9-4 9 4-9 4zM3 12l9 4 9-4M3 17l9 4 9-4',
  logout: 'M14 4h4a1 1 0 011 1v14a1 1 0 01-1 1h-4M10 12H3M6 8l-4 4 4 4',
  doc: 'M7 3h7l4 4v14H7zM9 12h6M9 16h6M9 8h3',
  flag: 'M5 21V4M5 4h11l-2 4 2 4H5',
  sliders: 'M4 6h10M18 6h2M4 12h2M10 12h10M4 18h12M20 18h0M14 4v4M6 10v4M16 16v4',
  image: 'M3 5h18v14H3zM3 16l5-5 4 4 3-3 6 6M15.5 9a1.5 1.5 0 100-3 1.5 1.5 0 000 3',
  grip: 'M9 5h.01M9 12h.01M9 19h.01M15 5h.01M15 12h.01M15 19h.01',
  copy: 'M9 9h11v11H9zM5 15H4V4h11v1',
  trash: 'M4 7h16M9 7V5h6v2M6 7l1 13h10l1-13M10 11v6M14 11v6',
  unlock: 'M6 11h12v9H6zM8 11V8a4 4 0 017-2.4',
  up: 'M12 19V5M6 11l6-6 6 6',
  down: 'M12 5v14M6 13l6 6 6-6',
  link: 'M9 15l6-6M10 6l1-1a3.5 3.5 0 015 5l-1 1M14 18l-1 1a3.5 3.5 0 01-5-5l1-1',
  list: 'M8 6h13M8 12h13M8 18h13M3.5 6h.01M3.5 12h.01M3.5 18h.01',
  telegram: 'M22 4L2.5 11.5l6 2M22 4l-3 15-7-5.5M22 4L8.5 13.5M8.5 13.5V19l3.5-3.5',
  camera: 'M4 8h3l1.6-2h6.8L17 8h3v11H4zM12 11.5a3 3 0 100 6 3 3 0 000-6',
  pencil: 'M4 20h4L19 9l-4-4L4 16zM14 6l4 4',
} as const;

export type IconName = keyof typeof ICON_PATHS;

export interface IconProps {
  name: IconName;
  size?: number;
  stroke?: number;
  fill?: boolean;
  style?: CSSProperties;
  className?: string;
}

export function Icon({ name, size = 20, stroke = 1.6, fill = false, style, className }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      className={className}
      style={{ flex: 'none', display: 'block', ...style }}
    >
      <path
        d={ICON_PATHS[name]}
        stroke="currentColor"
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill={fill ? 'currentColor' : 'none'}
      />
    </svg>
  );
}
